import { BASE_URL, ENDPOINT_URL } from "../../config/urlConfig.js";
import { ApiService } from "../../config/apiServices.js";
import { encryptJsonPayload, getPublicKey } from "../../utils/encryption.js";

/**
 * Utility: encrypt payload then POST. Falls back to plain POST on error.
 */
const encryptedPost = async (methodUrl, data) => {
  try {
    const publicKey = getPublicKey();

    if (publicKey) {
      const encryptedPayload = await encryptJsonPayload(data, publicKey);
      return ApiService.post(methodUrl, encryptedPayload);
    }

    console.warn("No public key found - sending unencrypted data");
    return ApiService.post(methodUrl, data);
  } catch (error) {
    console.error("Encryption error:", error);
    return ApiService.post(methodUrl, data);
  }
};

// Add enterprise
export const AddenterpriseApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.create;
  return encryptedPost(METHOD_URL, data);
};

export const ElementsSidebarApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.elements.left_side_bar;
  return encryptedPost(METHOD_URL, data);
};

export const enterpriseApi = () => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.getinterprise;
  return encryptedPost(METHOD_URL, {});
};

export const EditenterpriseApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.edit;
  return encryptedPost(METHOD_URL, data);
};

export const deleteEnterpriseApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.delete;
  return encryptedPost(METHOD_URL, data);
};

export const validateEnterpriseKeyApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.fetchkeysvalue;
  return encryptedPost(METHOD_URL, data);
};

export const getPreviousLicenseDetails = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.fetchpreviouslicensedetails;
  return encryptedPost(METHOD_URL, data);
};

export const getOrgAdminList = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.orgadminlist;
  return encryptedPost(METHOD_URL, data);
};

export const createAdminUser = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.createuser;
  return encryptedPost(METHOD_URL, data);
};

export const addEnterpriseForStcherApi = (data) => {
  const METHOD_URL = BASE_URL + ENDPOINT_URL?.enterprise.addenterpriseforstcher;
  return encryptedPost(METHOD_URL, data);
};